import { HttpClient } from 'shared/libs/http';
import {
   AdminActivateBlogDto,
   AdminActivateBlogResponse,
   AdminBlogIndexResponse,
   AdminDeactivateBlogDto,
   AdminDeactivateBlogResponse,
   AdminDeleteBlogDto,
   AdminDeleteBlogResponse,
   AdminGroupActionBlogDto,
} from './types';

export class BlogsManagerApiService {
   public static async getBlogs<TDto extends null>(
      dto: TDto,
      opt: { adminID?: string; tokenKey?: string } = {}
   ) {
      return await HttpClient.post<AdminBlogIndexResponse>('/admin/blog/index', null, {
         headers: {
            adminid: opt.adminID,
            Authorization: `Bearer ${opt.tokenKey}`,
         },
      });
   }

   public static async activateBlog<TDto extends AdminActivateBlogDto>(
      dto: TDto,
      opt: { adminID?: string; tokenKey?: string } = {}
   ) {
      return await HttpClient.post<AdminActivateBlogResponse>(
         '/admin/blog/admin_activateblog/' + dto.slug,
         null,
         {
            headers: {
               adminid: opt.adminID,
               Authorization: `Bearer ${opt.tokenKey}`,
            },
         }
      );
   }

   public static async deactivateBlog<TDto extends AdminDeactivateBlogDto>(
      dto: TDto,
      opt: { adminID?: string; tokenKey?: string } = {}
   ) {
      return await HttpClient.post<AdminDeactivateBlogResponse>(
         '/admin/blog/admin_deactivateblog/' + dto.slug,
         null,
         {
            headers: {
               adminid: opt.adminID,
               Authorization: `Bearer ${opt.tokenKey}`,
            },
         }
      );
   }

   public static async deleteBlog<TDto extends AdminDeleteBlogDto>(
      dto: TDto,
      opt: { adminID?: string; tokenKey?: string } = {}
   ) {
      return await HttpClient.post<AdminDeleteBlogResponse>(
         '/admin/blog/admin_deleteblogs/' + dto.slug,
         null,
         {
            headers: {
               adminid: opt.adminID,
               Authorization: `Bearer ${opt.tokenKey}`,
            },
         }
      );
   }

   /**
    * Group CRUD by blog Activated, Deactivate, Delete blogs
    */
   public static async groupAction<TDto extends AdminGroupActionBlogDto>(
      dto: TDto,
      opt: { adminID?: string; tokenKey?: string } = {}
   ) {
      return await HttpClient.post<AdminBlogIndexResponse>('/admin/blog/index', dto, {
         headers: {
            adminid: opt.adminID,
            Authorization: `Bearer ${opt.tokenKey}`,
         },
      });
   }
}
